import React, { useState, useEffect, useContext } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { useHistory } from "react-router";
import { CircularProgress, Snackbar } from "@material-ui/core";
import { Image, Shimmer } from "react-shimmer";
import { Alert } from "@material-ui/lab";
import moment from "moment";
import async from 'async';
import styles from "./index.module.css";
import { api_call_token } from "../../utils/Network";
import { MainContext } from "../../utils/context";
import { appendImageUrl, isMobiledevice } from "../../utils/helperFunctions";
import Grp from "../../assets/grps.png";
import Date from "../../components/Date/Date";
import TimeDrop from "../../components/TimeDrop/TimeDrop";
import LoginPopup from "../../components/LoginPopup";

const timeOptions = [
  "09:00 AM",
  "10:00 AM",
  "11:00 AM",
  "12:00 PM",
  "01:00 PM",
  "02:00 PM",
  "03:00 PM",
  "04:00 PM",
  "05:00 PM",
  "06:00 PM",
];

function ProceedCart() {
  const { userData, cartData, setCartData, setCurrentPath, slots, setSlots } =
    useContext(MainContext);
  const [loading, setLoading] = useState(false);
  const [loginPopup, setLoginPopup] = useState(false);
  const [msg, setMsg] = useState("");
  const [dates, setDate] = useState("");
  // const [slots, setSlots] = useState([]);
  const [selected, setSelected] = useState(null);
  const [selbool, setSelBool] = useState(false);
  const history = useHistory();

  useEffect(() => setCurrentPath(window.location.href.split("/")[4]), []);
  useEffect(() => getCartData(), [userData.id]);
  useEffect(() => { }, [cartData]);
  useEffect(() => getSlots(), [cartData]);


  const getSlotss = (ids, dates, ser_id) => {
    api_call_token
      .post("auth/cart/order_slots/", {
        service_id: ser_id,
        date: dates,
      })
      .then((re) => {
        const res = re.data.data;
        slots[ids] = res;
      }).catch(err => console.log(err));
  }

  const getSlots = async () => {
    let totalslots = [];
    if (cartData.length) {

      // Using callbacks
      async.map(cartData, (vals, cb) => {
        api_call_token
          .post("auth/cart/order_slots/", {
            service_id: vals.service_id,
            date: vals?.order_booking_date,
          })
          .then((res) => {
            const resp = res.data.data;
            // totalslots[idx] = resp;
            return cb(null, resp)

            // setSlots(totalslots);
            // if(cartData.length === idx+1){
            //   setSelBool(true)
            // }
          })
          .catch((err) => cb(err));
      }, function (err, results) {
        if (err) {
          console.log(err, 'callback error');
        } else {
          console.log(results, 'callback result');
          setSlots(results);

        }
      });


      // cartData.map((vals, idx) => {
      //   api_call_token
      //     .post("auth/cart/order_slots/", {
      //       service_id: vals.service_id,
      //       date: vals?.order_booking_date,
      //     })
      //     .then((res) => {
      //       const resp = res.data.data;
      //       totalslots[idx] = resp;
      //       setSlots(totalslots);
      //       // if(cartData.length === idx+1){
      //       //   setSelBool(true)
      //       // }
      //     })
      //     .catch((err) => console.log(err));
      // })
      // console.log(2,"dddd")
    }
    // document.location.reload();
  };

  const getCartData = () => {
    if (userData?.id) {
      setLoading(true);
      api_call_token
        .get("auth/cart/view_cart/")
        .then((res) => {
          if (res.data?.data?.length) {
            setCartData(
              res.data.data.map((c, i) => ({
                ...c,
                order_booking_date:
                  cartData[i]?.order_booking_date ||
                  moment().add(1, "days").format("DD-MM-YYYY"),
                order_booking_time:
                  cartData[i]?.order_booking_time || timeOptions[0],
                booking_time_slot: cartData[i]?.booking_time_slot || selected,
                book: cartData[i]?.book,
              }))
            );
          } else setCartData([]);
          setLoading(false);
        })
        .catch((e) => console.log(e));
    } else {
      setMsg("Please login first");
    }
  };

  const removeCartItemHandler = (itemId = 0, itemIndex = 0) => {
    if (userData?.id) {
      api_call_token
        .post("auth/cart/remove_cart/", { cart_id: itemId })
        .then((r) => getCartData())
        .catch((e) => console.log(e));
    } else if (itemIndex) {
      cartData[itemIndex - 1].sub_service = cartData[
        itemIndex - 1
      ].sub_service.filter((adn) => adn.service_id !== itemId);
      setCartData(cartData);
    } else setCartData(cartData.filter((itm) => itm.price_id !== itemId));
    setTimeout(() => setMsg("Updated Cart Successfully"), 1000);
  };

  const checkoutHandler = () => {
    if (userData.id) history.push("/checkout");
    else {
      setLoginPopup(true);
      setMsg("Please login first");
    }
  };

  const setTime = (x, z) => {
    setSelected(x.id);
    cartData.map((v, i) => {
      if (v.id === z.id) {
        cartData[i].book = x;
        cartData[i].booking_time_slot = x.id;
        setCartData(cartData)
      }
    })
  };
  console.log(cartData, "cartData")
  return (
    <>
      <LoginPopup
        show={loginPopup}
        onSuccess={(ms) => (setMsg(ms), setLoginPopup(false))}
        onClose={() => setLoginPopup(false)}
        updateUser={{}}
      />
      {msg && (
        <Snackbar
          open
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          onClose={() => setMsg("")}
          autoHideDuration={3000}
          message={msg}
        >
          <Alert severity={msg.includes("leas") ? "error" : "success"}>
            {msg}
          </Alert>
        </Snackbar>
      )}
      <div className={`${styles.cartHeader} ${styles.cart_main}`}>
        <div className={styles.cart_contents}>
          <h2 style={{ margin: 0 }}>Cart</h2>
        </div>
        {cartData.length > 0 && (
          <div>
            <button onClick={checkoutHandler} className={styles.btn_proceed}>
              Proceed to Checkout
            </button>
          </div>
        )}
      </div>
      <div className={styles.cart_content}>
        {cartData.length > 0 ? (
          <>
            {cartData.map((cartItem, i) => (
              <>
                <div key={cartItem.service_id} className={styles.cart_datas}>
                  <div
                    className={`${styles.cart_main} ${styles.cart_container}`}
                  >
                    <div className={styles.Cart_content_wrapper}>
                      <Image
                        src={appendImageUrl(
                          cartItem.service_image
                            ? cartItem.service_image
                            : "/files/files/Group_472x_Wj1mM5u.png"
                        )}
                        NativeImgProps={{ className: styles.CartImg }}
                        fallback={
                          <Shimmer
                            height={isMobiledevice() ? 50 : 90}
                            width={isMobiledevice() ? 50 : 90}
                            className={styles.CartImg}
                          />
                        }
                      />
                      <div>
                        <div style={{ display: "flex" }}>
                          <h3 className={styles.ccw_head}>
                            {cartItem.sq_feet
                              ? cartItem.service_name +
                              ` (${cartItem.sq_feet} sq.ft)`
                              : cartItem.service_name}
                          </h3>
                          <div
                            onClick={() =>
                              removeCartItemHandler(
                                cartItem.id || cartItem.price_id
                              )
                            }
                            className={styles.closeIcon}
                          >
                            <AiOutlineClose style={{ color: "grey" }} />
                          </div>
                        </div>
                        {/* <p className={styles.ccw_para}>
                        Lorem ipsum dolar sit amet, consecteturer adipiscing
                        elit, sed diam
                      </p> */}
                        <div className={styles.dateTime}>
                          <Date
                            value={cartItem.order_booking_date}
                            onChange={(v) => {
                              let crt = cartData;
                              crt[i].order_booking_date = v;
                              // setCartData(crt);
                              getSlotss(i, crt[i].order_booking_date, cartItem.service_id);
                              setDate(crt[i].order_booking_date);
                            }}
                          />
                          {/* <TimeDrop
                          options={timeOptions}
                          selectedOption={cartItem.order_booking_time}
                          onChange={(j) => {
                            let crt = cartData;
                            crt[i].order_booking_time = timeOptions[j];
                            setCartData(crt);
                          }}
                          // selectedOption={cartItem.time || timeOptions[0]}
                          // onChange={(i) => cartItem.time = (timeOptions[i])}
                        /> */}
                        </div>
                        <div className={styles.slots_data}>
                          {slots[i] && slots.length > 0 && slots[i] !== undefined && slots[i].map((v, i) => (
                            <button
                              key={v.id}
                              className={styles.slot_select}
                              disabled={!v.available}
                              style={{
                                backgroundColor:
                                  v.id === cartItem.booking_time_slot ? "#673c69" : "",
                                color: v.id === cartItem.booking_time_slot ? "white" : "",
                              }}
                              onClick={() => {
                                setTime(v, cartItem);
                              }}
                            >
                              <p style={{ margin: "0" }}>{v.slot}</p>
                              <p
                                style={{ margin: "5px 0" }}
                              >{`${v.from} - ${v.to}`}</p>
                              <p style={{ margin: "5px 0" }}>
                                Available : {v.total - v.occupied}
                              </p>
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className={styles.prd_drp_amt}>
                      <div className={styles.drp}>
                        {cartItem.variant_type +
                          " - " +
                          cartItem.sub_variant_type}
                      </div>
                      <div className={styles.Amt_Detail}>
                        {/* <div className="Save">Save 50%</div> */}
                        <div className={styles.amount}>
                          &#8377;
                          {cartItem.sq_feet
                            ? (
                              cartItem.service_price * cartItem.sq_feet
                            ).toFixed(2)
                            : cartItem.service_price}
                        </div>
                      </div>
                    </div>
                  </div>
                  {cartItem.sub_service?.length > 0 && (
                    <div className={`${styles.cart_main} ${styles.adons_data}`}>
                      <h4>Add Ons</h4>
                      {cartItem.sub_service.map((addon) => (
                        <div
                          key={addon.service_id}
                          className={styles.adon_container}
                        >
                          <div className={styles.adon_main_wrapper}>
                            <Image
                              src={appendImageUrl(
                                addon.service_image
                                  ? addon.service_image
                                  : "/files/files/Group_1112x_uioXQAd.png"
                              )}
                              NativeImgProps={{ className: styles.adonImg }}
                              fallback={
                                <Shimmer
                                  height={55}
                                  width={55}
                                  className={styles.adonImg}
                                />
                              }
                            />
                            <h4 className={styles.adon_paras}>
                              {addon.quantity > 1
                                ? addon.service_name + ` (${addon.quantity})`
                                : addon.service_name}
                            </h4>
                            <div
                              className={styles.closeIcon}
                              onClick={() =>
                                removeCartItemHandler(
                                  addon.id || addon.service_id,
                                  i + 1
                                )
                              }
                              style={{
                                fontSize: 18,
                                width: 20,
                                height: 20,
                                marginTop: 2,
                              }}
                            >
                              <AiOutlineClose style={{ color: "grey" }} />
                            </div>
                          </div>
                          <div className={styles.adon_amount}>
                            {" "}
                            &#8377;{addon.quantity * addon.service_price}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </>
            ))}
            <div className={`${styles.cart_main} ${styles.btn_main_proceed}`}>
              <button
                onClick={() => history.push("/")}
                className={`${styles.btn_cb} ${styles.btn_proceed} `}
              >
                Continue Browsing
              </button>
              <button
                onClick={checkoutHandler}
                className={` ${styles.btn_pc} ${styles.btn_proceed} `}
              >
                Proceed To Checkout
              </button>
            </div>
          </>
        ) : loading ? (
          <div style={{ margin: 100, textAlign: "center" }}>
            <CircularProgress size={75} />
          </div>
        ) : (
          <div className={styles.no_data_main}>
            <div className={styles.no_data_container}>
              <img src={Grp} alt="circle" className={styles.no_data_img}></img>
              <div>
                <h1 className={styles.no_data_title}>Oops !</h1>
                <p className={styles.no_data_content}>
                  Looks like you don't have anything in your cart
                </p>
              </div>
            </div>
            <button
              className={styles.no_browse}
              onClick={() => history.push("/")}
            >
              Browse Services
            </button>
          </div>
        )}
        {/* <div className="cart-main">
          <h2 className="ss_service">
            <span>Saved Services</span>
          </h2>
        </div>
        {[1, 2].map((i) => (
          <div key={i} className="cart_datas">
            <div className="cart-main cart_container">
              <div className="Cart_content_wrapper">
                <div className="CartImg"></div>
                <div>
                  <div style={{ display: "flex" }}>
                    <h3 className="ccw_head">Basic Home Cleaning</h3>
                    <div className="closeIcon">
                      <AiOutlineClose style={{ color: "grey" }} />
                    </div>
                  </div>
                  <p className="ccw_para">
                    Lorem ipsum dolar sit amet, consecteturer adipiscing elit,
                    sed diam
                  </p>
                </div>
              </div>
              <div className="Amt_Detail">
                <div className="Save">Save 50%</div>
                <div className="amount">&#8377; 1000</div>
              </div>
            </div>
          </div>
        ))} */}
      </div>
    </>
  );
}

export default ProceedCart;
